<div class="unruly-navigation-wrapper" [ngClass]="{'collapsed': isCollapsed}">

  <div class="logo">
    <a (click)="navigateHome()" nz-tooltip nzTooltipPlacement="right" style="display: flex">
      <company-logo-svg
        [includeProductLogo]="true"
        [collapsed]="isCollapsed"
        [fill]="'#FFFFFF'">
      </company-logo-svg>
    </a>
    <div *ngIf="!isCollapsed && filteredNavContextList.length === 1 && filteredNavContextList[0].productLineLabel" 
      class="logo-product-line">{{filteredNavContextList[0].productLineLabel}}</div>
  </div>


  <div class="overflow-wrapper">

    <ng-container *ngIf="filteredNavContextList.length > 1">
      <ng-container *ngIf="isCollapsed; else contextSwitch">
        <div class="fixed-context-switch-wrapper" #collapsedContextSwitchWrapperEl>
           <app-unruly-navigation-item
            [parent]="collapsedContextSwitchNavConfig"
            [isCollapsed]="isCollapsed"
            (clicked)="onContextSwitch($event.payload.context)">
            <div #projectedIcon class="collapsed-context-switch-label">
              <span class="ellipsisText-withoutDots">{{getCurrentContextTitle(4)}}</span>
              <fa-icon icon="caret-down"></fa-icon>
            </div>     
          </app-unruly-navigation-item>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #contextSwitch>
      <div class="context-switch" [ngClass]="{'collapsed': isCollapsed, 'no-context-index': currentContextIndex === -1}" 
        [style.--current-context-index]="currentContextIndex | sanitizer: 'style'">
        <span #switchBtn *ngFor="let context of filteredNavContextList" (click)="onContextSwitch(context.key)"
          class="context-switch-btn" [ngClass]="{'selected': context.key === currentContext}">{{context.title}}</span>
      </div>
    </ng-template>

    <nav class="flex-1" aria-label="">
      <ul>
        <ng-container *ngIf="filteredNavContextList.length && !isFeatureToggleLoading(); else skeletonTop">
          <ng-container *ngFor="let context of filteredNavContextList">
            <ng-container *ngIf="context.key === currentContext">
              <li #navItem *ngFor="let parent of context.navItems" 
                [@heightChange]="{
                  value: parent.showChildren,
                  params: {
                    startHeight: navItem.clientHeight
                  }
                }">
                <app-unruly-navigation-item
                  [parent]="parent"
                  [isCollapsed]="isCollapsed"
                  (clicked)="onItemAction($event)">
                </app-unruly-navigation-item>
              </li>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #skeletonTop>
          <ng-container *ngFor="let width of [120, 100, 150, 80]">
            <ng-container *ngTemplateOutlet="skeleton; context: { width }"></ng-container>
          </ng-container>
        </ng-template>
      </ul>
    </nav>
  </div>

</div>


<ng-template #skeleton let-width="width">
  <nz-skeleton class="padding-left-1 padding-block-smallest margin-block-1"
    [nzAvatar]="{size: 'small', shape: 'circle'}"
    [nzTitle]="false"
    [nzParagraph]="isCollapsed ? false : {rows: 1, width}"
    nzActive="true"></nz-skeleton>
</ng-template>
